// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__lOdmL","label":"LanguagePicker_label__p4CCY","icon":"LanguagePicker_icon__MVj2Y"};